export const GET_RECENT_SEARCH_START = 'GET_RECENT_SEARCH_START';
export const GET_RECENT_SEARCH_FAILURE = 'GET_RECENT_SEARCH_FAILURE';
export const GET_RECENT_SEARCH_SUCCESS = 'GET_RECENT_SEARCH_SUCCESS';
export const GET_RECENT_SEARCH_ERROR = 'GET_RECENT_SEARCH_ERROR';
